export const labels = {
	symbols: {
		label: "Label.MobileCreator.BottomMenu.Symbols.SymbolsList",
		default: "Symbols",
	},
	position: {
		label: "Label.MobileCreator.BottomMenu.Symbols.Position",
		default: "Position",
	},
	delete: {
		label: "Label.MobileCreator.BottomMenu.Symbols.Delete",
		default: "Delete",
	},
} as const;
